//import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FMPSelect from "../pureForm/FMPSelect";
import {regions} from "../../libs/regions";

class FMPRegionPicker extends PureComponent {
	render () {
		const {
			label, value, path, onChange,
			error, helpText, md, disabled
		} = this.props;

		return (
			<FMPSelect
				label={label}
				path={path}
				value={value}
				error={error}
				options={regions}
				onChange={onChange}
				md={md}
				helpText={helpText}
				disabled={disabled}
			/>
		);
	}
}

FMPRegionPicker.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	classes : PropTypes.object,
	md : PropTypes.number,
	helpText : PropTypes.string,
	productTypes : PropTypes.array,
	disabled : PropTypes.bool,

	dataDumpMap : PropTypes.object,
};

FMPRegionPicker.defaultProps =  {
	md : 12,
	label : 'Select region',
};
export default FMPRegionPicker;
